import { Component, Input } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { User } from 'src/app/model/user';

@Component({
  selector: 'completed-assignment-modal',
  templateUrl: './completed-assignment-modal.component.html',
  styleUrls: ['./completed-assignment-modal.component.scss'],
})
export class CompletedAssignmentModalComponent {
  @Input()
  user: User;

  @Input()
  message: String;

  @Input()
  orangeThumbsUp: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CompletedAssignmentModalComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
